import { SendEmailVerificationCodeArgs } from 'types/api/arguments/send-email-verification-code-args'
import { SendEmailVerificationCodeResp } from 'types/api/response/send-email-verification-code-resp'

import { api } from './api'

export const sendEmailVerificationCode = ({ userId, email }: SendEmailVerificationCodeArgs) =>
  api.post<SendEmailVerificationCodeResp>(`/users/${userId}/verifications/email_code`, {
    email,
  })
